export const clientsTranslations = {
  en: {
    title: 'Client Management',
    description: 'Manage your client database, including contact information and business details.',
    addClient: 'Add Client',
    search: 'Search clients...',
    noClients: 'No clients found',
    pagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      clients: 'clients',
      previous: 'Previous',
      next: 'Next'
    },
    filters: {
      title: 'Filters',
      entityType: 'Entity Type',
      service: 'Service',
      status: 'Status',
      sortBy: 'Sort By',
      clearAll: 'Clear all filters',
      missingTaxInfo: 'Missing VAT/Tax Code',
      taxId: 'Tax ID'
    },
    viewMode: {
      list: 'List View',
      grid: 'Grid View'
    },
    status: {
      inserted: 'Inserted',
      in_progress: 'In Progress',
      pending: 'Pending',
      completed: 'Completed',
      draft: 'Draft',
      sent: 'Sent',
      accepted: 'Accepted',
      rejected: 'Rejected'
    },
    leads: {
      title: 'Lead Management',
      description: 'Manage potential clients through your sales pipeline',
      addLead: 'Add Lead',
      convert: 'Convert to Client',
      noLeads: 'No leads found',
      search: 'Search leads...',
      stages: {
        new: 'New',
        contacted: 'Contacted',
        qualified: 'Qualified',
        proposal: 'Proposal',
        negotiation: 'Negotiation',
        closed_won: 'Closed Won',
        closed_lost: 'Closed Lost'
      },
      qualification: {
        title: 'Lead Qualification',
        budget: 'Budget',
        authority: 'Authority',
        need: 'Need',
        timeframe: 'Timeframe',
        score: 'Qualification Score',
        notes: 'Qualification Notes'
      }
    },
    form: {
      entityType: {
        title: 'Entity Type',
        company: 'Company',
        individual: 'Individual'
      },
      clientCode: {
        label: 'Client Code',
        hint: 'Optional internal reference code'
      },
      businessInfo: {
        title: 'Business Information',
        businessName: 'Business Name',
        vatNumber: 'VAT Number',
        taxCode: 'Tax Code',
        sdiCode: 'SDI Code',
        atecoCode: 'ATECO Code',
        chamberOfCommerce: 'Chamber of Commerce',
        category: 'Client Category',
        defaultPaymentMethod: 'Default Payment Method',
        paymentMethodHint: 'Default payment method used for this client',
        accountingRegime: {
          label: 'Accounting Regime',
          options: {
            ordinario: 'Ordinary Regime',
            semplificato: 'Simplified Regime',
            forfettario: 'Flat-rate Regime',
            contribuenti_minimi: 'Minimum Taxpayers Regime',
            agricoltura: 'Agricultural Regime',
            inserted: 'Inserted',
            in_progress: 'In Progress',
            pending: 'Pending',
            completed: 'Completed'
          }
        },
        categoryOptions: {
          label: 'Category',
          placeholder: 'Select category...',
          artigiano: 'Artisan',
          professionista: 'Professional',
          commerciante: 'Retailer',
          industria: 'Industry',
          agricoltura: 'Agriculture',
          altro: 'Other'
        }
      },
      address: {
        title: 'Address',
        streetAddress: 'Street Address',
        streetNumber: 'Street Number',
        postalCode: 'Postal Code',
        city: 'City',
        province: 'Province'
      },
      contact: {
        title: 'Contact Information',
        phone: 'Phone',
        email: 'Email',
        pec: 'PEC',
        whatsapp: 'WhatsApp',
        countryCode: 'Country Code'
      },
      customFields: {
        title: 'Custom Fields',
        addField: 'Add Field',
        fieldName: 'Field Name',
        value: 'Value'
      },
      assignedTo: {
        label: 'Account Manager',
        placeholder: 'Select account manager...'
      },
      buttons: {
        create: 'Create Client',
        update: 'Update Client',
        cancel: 'Cancel'
      }
    },
    details: {
      title: 'Client Details',
      dashboard: 'Dashboard',
      tabs: {
        details: 'Client Details',
        dashboard: 'Dashboard'
      },
      sections: {
        clientCode: 'Client Code',
        entityType: 'Entity Type',
        assignedTo: 'Assigned To',
        businessInfo: 'Business Information',
        address: 'Address',
        contact: 'Contact Information',
        customFields: 'Custom Fields',
        deals: 'Deals',
        projects: 'Projects',
        tickets: 'Tickets'
      },
      actions: {
        copy: 'Copy',
        navigate: 'Navigate',
        edit: 'Edit',
        back: 'Back to Clients'
      },
      emailTimeline: {
        summaryTitle: 'Email summary',
        generating: 'Generating summary…',
        regenerate: 'Update summary',
        newEmails: '{count} new emails',
        updatedAt: 'Updated',
        lastInteraction: 'Last email',
        threadsCount: '{threads} conversations · {messages} messages',
        messages: 'messages',
        mailboxOf: 'Mailbox of',
        openInGmail: 'Open in Gmail',
        openInOutlook: 'Open in Outlook',
        loadMore: 'Load more emails',
        loadError: 'Unable to load emails',
        noSubject: '(no subject)'
      }
    }
  },
  it: {
    title: 'Gestione Clienti',
    description: 'Gestisci il database clienti, incluse le informazioni di contatto e i dettagli aziendali.',
    addClient: 'Aggiungi Cliente',
    search: 'Cerca clienti...',
    noClients: 'Nessun cliente trovato',
    pagination: {
      showing: 'Visualizzazione',
      to: 'a',
      of: 'di',
      clients: 'clienti',
      previous: 'Precedente',
      next: 'Successivo'
    },
    filters: {
      title: 'Filtri',
      entityType: 'Tipo Entità',
      service: 'Servizio',
      status: 'Stato',
      sortBy: 'Ordina per',
      clearAll: 'Cancella tutti i filtri',
      missingTaxInfo: 'Senza P.IVA/Cod. Fiscale',
      taxId: 'P.IVA/Cod. Fiscale'
    },
    viewMode: {
      list: 'Vista Lista',
      grid: 'Vista Griglia'
    },
    status: {
      inserted: 'Inserito',
      in_progress: 'In Lavorazione',
      pending: 'In Attesa',
      completed: 'Completato',
      draft: 'Bozza',
      sent: 'Inviato',
      accepted: 'Accettato',
      rejected: 'Rifiutato'
    },
    leads: {
      title: 'Gestione Lead',
      description: 'Gestisci potenziali clienti attraverso il tuo processo di vendita',
      addLead: 'Aggiungi Lead',
      convert: 'Converti in Cliente',
      noLeads: 'Nessun lead trovato',
      search: 'Cerca lead...',
      stages: {
        new: 'Nuovo',
        contacted: 'Contattato',
        qualified: 'Qualificato',
        proposal: 'Proposta',
        negotiation: 'Negoziazione',
        closed_won: 'Chiuso (Vinto)',
        closed_lost: 'Chiuso (Perso)'
      },
      qualification: {
        title: 'Qualificazione Lead',
        budget: 'Budget',
        authority: 'Autorità',
        need: 'Necessità',
        timeframe: 'Tempistiche',
        score: 'Punteggio di Qualificazione',
        notes: 'Note di Qualificazione'
      }
    },
    form: {
      entityType: {
        title: 'Tipo Entità',
        company: 'Azienda',
        individual: 'Persona Fisica'
      },
      clientCode: {
        label: 'Codice Cliente',
        hint: 'Codice di riferimento interno opzionale'
      },
      businessInfo: {
        title: 'Informazioni Aziendali',
        businessName: 'Ragione Sociale',
        vatNumber: 'Partita IVA',
        taxCode: 'Codice Fiscale',
        sdiCode: 'Codice SDI',
        atecoCode: 'Codice ATECO',
        chamberOfCommerce: 'Camera di Commercio',
        category: 'Categoria Cliente',
        defaultPaymentMethod: 'Metodo di Pagamento Predefinito',
        paymentMethodHint: 'Metodo di pagamento predefinito utilizzato per questo cliente',
        accountingRegime: {
          label: 'Regime Fiscale',
          options: {
            ordinario: 'Regime Ordinario',
            semplificato: 'Regime Semplificato',
            forfettario: 'Regime Forfettario',
            contribuenti_minimi: 'Regime dei Contribuenti Minimi',
            agricoltura: 'Regime Speciale Agricoltura',
            inserted: 'Inserito',
            in_progress: 'In Lavorazione',
            pending: 'In Attesa',
            completed: 'Completato'
          }
        },
        categoryOptions: {
          label: 'Categoria',
          placeholder: 'Seleziona categoria...',
          artigiano: 'Artigiano',
          professionista: 'Professionista',
          commerciante: 'Commerciante',
          industria: 'Industria',
          agricoltura: 'Agricoltura',
          altro: 'Altro'
        }
      },
      address: {
        title: 'Indirizzo',
        streetAddress: 'Via',
        streetNumber: 'Numero Civico',
        postalCode: 'CAP',
        city: 'Città',
        province: 'Provincia'
      },
      contact: {
        title: 'Informazioni di Contatto',
        phone: 'Telefono',
        email: 'Email',
        pec: 'PEC',
        whatsapp: 'WhatsApp',
        countryCode: 'Prefisso Internazionale'
      },
      customFields: {
        title: 'Campi Personalizzati',
        addField: 'Aggiungi Campo',
        fieldName: 'Nome Campo',
        value: 'Valore'
      },
      assignedTo: {
        label: 'Responsabile Anagrafica',
        placeholder: 'Seleziona responsabile...'
      },
      buttons: {
        create: 'Crea Cliente',
        update: 'Aggiorna Cliente',
        cancel: 'Annulla'
      }
    },
    details: {
      title: 'Dettagli Cliente',
      dashboard: 'Dashboard',
      tabs: {
        details: 'Dettagli Cliente',
        dashboard: 'Dashboard'
      },
      sections: {
        clientCode: 'Codice Cliente',
        entityType: 'Tipo Entità',
        assignedTo: 'Assegnato a',
        businessInfo: 'Informazioni Aziendali',
        address: 'Indirizzo',
        contact: 'Informazioni di Contatto',
        customFields: 'Campi Personalizzati',
        deals: 'Offerte',
        projects: 'Progetti',
        tickets: 'Ticket'
      },
      actions: {
        copy: 'Copia',
        navigate: 'Naviga',
        edit: 'Modifica',
        back: 'Torna ai Clienti'
      },
      emailTimeline: {
        summaryTitle: 'Riassunto email',
        generating: 'Generazione riassunto…',
        regenerate: 'Aggiorna riassunto',
        newEmails: '{count} nuove email',
        updatedAt: 'Aggiornato',
        lastInteraction: 'Ultima email',
        threadsCount: '{threads} conversazioni · {messages} messaggi',
        messages: 'messaggi',
        mailboxOf: 'Casella di',
        openInGmail: 'Apri in Gmail',
        openInOutlook: 'Apri in Outlook',
        loadMore: 'Carica altre email',
        loadError: 'Impossibile caricare le email',
        noSubject: '(nessun oggetto)'
      }
    }
  }
};